// ============================================================
// TESTIMONIALS — DEMO PLACEHOLDERS ONLY
// These are NOT real patient reviews. Replace each entry with
// genuine patient feedback once the hospital provides it.
// ============================================================

export const TESTIMONIALS = [
  {
    quote: "Patient feedback will appear here.",
    name: "Patient Name",
    detail: "Demo placeholder — replace with a real patient review",
    isDemo: true,
  },
  {
    quote: "Patient feedback will appear here.",
    name: "Patient Name",
    detail: "Demo placeholder — replace with a real patient review",
    isDemo: true,
  },
  {
    quote: "Patient feedback will appear here.",
    name: "Patient Name",
    detail: "Demo placeholder — replace with a real patient review",
    isDemo: true,
  },
];
